<p-toast></p-toast>
<p-card styleClass="p-card-shadow mt-2">
    <div class="card dashboardTable">
        <p-toolbar styleClass="mb-4">
            <ng-template pTemplate="left">
                <!-- <button pButton icon="pi pi-fw pi-plus" label="Add Bank Details" (click)="openNew()"
                    class="p-button-success"></button> -->
                <!-- <button pButton pRipple  icon="pi pi-trash" class="ml-4 p-button-danger" (click)="deleteSelectedProducts()" [disabled]="!selectedBankAccounts || !selectedBankAccounts.length"></button> -->
            </ng-template>
            <ng-template pTemplate="right">
                <!-- <p-fileUpload accept=".jpeg,.pdf,.jpg" mode="basic" [maxFileSize]="5000000" label="Import" chooseLabel="Import" class="mr-2 inline-block"></p-fileUpload> -->
                <button (click)="menu.toggle($event)" pButton pRipple label="{{'EXPORT'| translate}}" icon="pi pi-upload"
                    class="p-button-help"></button>
               
                <p-menu #menu [popup]="true" [model]="appVerificationItems"></p-menu>
            </ng-template>    
        </p-toolbar>
        <p-table #miSurvey [value]="miVerfSubsidy"  dataKey="AppId_ProgID"
        [rows]="10"
        [paginator]="true" [globalFilterFields]="[
        'District',
		'Block',
		'Constituency',
		'Village',
		'Application_No',
		'farmerName',
		'Father_name',
		'ProgrammeName',
        'TotalArea',
        'EstimateAmount',
        'BOQAmount',
        'PVAmount',
        'verification_date',
        'Mobile',
        'VendorName',
        ]" responsiveLayout="scroll" [rowHover]="true" dataKey="Scheme_Specific_Id"
        currentPageReportTemplate="{{'SHOWING'| translate}} {first} {{'TO'| translate}} {last} {{'OF'| translate}} {totalRecords} {{'ENTRIES'| translate}}"
        [showCurrentPageReport]="true"
        (onFilter)="tableDataFunction($event)"
        (onPage)="onPage($event)" [loading]="loading">
        <ng-template pTemplate="caption">
            <div class="flex align-items-center justify-content-between">
                <h5 class="m-0">{{'MI_VERIFICATION_SUBSIDY_REPORT' | translate}}</h5>
                <span class="p-input-icon-left">
                    <i class="pi pi-search"></i>
                    <input pInputText type="text"
                        (input)="miSurvey.filterGlobal($any($event.target).value, 'contains')"
                        placeholder="{{'SEARCH'| translate}}" />
                </span>
            </div>
        </ng-template>
        <ng-template pTemplate="header">
            <tr>
                             
                <th pSortableColumn="District">{{'DISTRICT'| translate}}
                    <p-columnFilter type="text" field="District" display="menu"></p-columnFilter>
                    <p-sortIcon field="District"></p-sortIcon>
                </th>
                <th pSortableColumn="Block">{{'BLOCK'| translate}}
                    <p-columnFilter type="text" field="Block" display="menu"></p-columnFilter>
                    <p-sortIcon field="Block"></p-sortIcon>
                </th>
                <th pSortableColumn="Constituency">{{'CONSTITUENCY'| translate}}
                    <p-columnFilter type="text" field="Constituency" display="menu"></p-columnFilter>
                    <p-sortIcon field="Constituency"></p-sortIcon>
                </th>
                <th pSortableColumn="Village">{{'VILLAGE'| translate}}
                    <p-columnFilter type="text" field="Village" display="menu"></p-columnFilter>
                    <p-sortIcon field="Village"></p-sortIcon>
                </th>
                <th pSortableColumn="Application_No">{{'APPLICATION_NO'| translate}}
                    <p-columnFilter type="text" field="Application_No" display="menu"></p-columnFilter>
                    <p-sortIcon field="Application_No"></p-sortIcon>
                </th>
                <th pSortableColumn="farmerName">{{'FARMER_NAME'| translate}}
                    <p-columnFilter type="text" field="farmerName" display="menu"></p-columnFilter>
                    <p-sortIcon field="farmerName"></p-sortIcon>
                </th>
                <th pSortableColumn="Father_name">{{'FATHER_NAME'| translate}}
                    <p-columnFilter type="text" field="Father_name" display="menu"></p-columnFilter>
                    <p-sortIcon field="Father_name"></p-sortIcon>
                </th>
                <th pSortableColumn="ProgrammeName">{{'PROGRAMME_NAME'| translate}}
                    <p-columnFilter type="text" field="ProgrammeName" display="menu"></p-columnFilter>
                    <p-sortIcon field="ProgrammeName"></p-sortIcon>
                </th>
                <th pSortableColumn="TotalArea">{{'TOTAL_AREA'| translate}}
                    <p-columnFilter type="text" field="TotalArea" display="menu"></p-columnFilter>
                    <p-sortIcon field="TotalArea"></p-sortIcon>
                </th>
                <th pSortableColumn="EstimateAmount">{{'ESTIMATE_AMOUNT'| translate}}
                    <p-columnFilter type="text" field="EstimateAmount" display="menu"></p-columnFilter>
                    <p-sortIcon field="EstimateAmount"></p-sortIcon>
                </th>
                <th pSortableColumn="BOQAmount">{{'BOQ_AMOUNT'| translate}}
                    <p-columnFilter type="text" field="BOQAmount" display="menu"></p-columnFilter>
                    <p-sortIcon field="BOQAmount"></p-sortIcon>
                </th>
                <th pSortableColumn="PVAmount">{{'PV_AMOUNT'| translate}}
                    <p-columnFilter type="text" field="PVAmount" display="menu"></p-columnFilter>
                    <p-sortIcon field="PVAmount"></p-sortIcon>
                </th>
                <th pSortableColumn="verification_date">{{'VERIFICATION_DATE'| translate}}
                    <p-columnFilter type="text" field="verification_date" display="menu"></p-columnFilter>
                    <p-sortIcon field="verification_date"></p-sortIcon>
                </th>
                <th pSortableColumn="Mobile">{{'MOBILE'| translate}}
                    <p-columnFilter type="text" field="Mobile" display="menu"></p-columnFilter>
                    <p-sortIcon field="Mobile"></p-sortIcon>
                </th>
                <th pSortableColumn="VendorName">{{'VENDOR_NAME'| translate}}
                    <p-columnFilter type="text" field="VendorName" display="menu"></p-columnFilter>
                    <p-sortIcon field="VendorName"></p-sortIcon>
                </th>

            
            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-miVerfSubsidy>
            <tr>
                <td>{{miVerfSubsidy.District}}</td>
                <td>{{miVerfSubsidy.Block}}</td>
                <td>{{miVerfSubsidy.Constituency}}</td>
                <td>{{miVerfSubsidy.Village}}</td>
                <td>{{miVerfSubsidy.Application_No}}</td>
                <td>{{miVerfSubsidy.farmerName}}</td>
                <td>{{miVerfSubsidy.Father_name}}</td>
                <td>{{miVerfSubsidy.ProgrammeName}}</td>
                <td>{{miVerfSubsidy.TotalArea}}</td>
                <td>{{miVerfSubsidy.EstimateAmount}}</td>
                <td>{{miVerfSubsidy.BOQAmount}}</td>
                <td>{{miVerfSubsidy.PVAmount}}</td>
                <td>{{miVerfSubsidy.verification_Date}}</td>
                <td>{{miVerfSubsidy.Mobile}}</td>
                <td>{{miVerfSubsidy.VendorName}}</td>
                
            </tr>
        </ng-template>
        <ng-template pTemplate="footer">
            <tr>
                <td >  Total</td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td >{{totalArea | number:'1.0-2'}}</td>
                <td >{{estAmount | number:'1.0-2'}}</td>
                <td >{{boqAmount | number:'1.0-2'}}</td>
                <td >{{pvaAmount | number:'1.0-2'}}</td>
                <td></td>
                <td></td>
                <td></td>
            </tr>
            <tr>
                <td > Grand Total</td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td >{{grandTotalArea | number:'1.0-2'}}</td>
                <td >{{grandEstAmount | number:'1.0-2'}}</td>
                <td >{{grandBoqAmount | number:'1.0-2'}}</td>
                <td >{{grandPvaAmount | number:'1.0-2'}}</td>
                <td></td>
                <td></td>
                <td></td>
            </tr>
        </ng-template>
    
        </p-table>
    </div>
    </p-card>